import { Button, Grid } from '@mui/material';
import React from 'react';

const CustomButton = ({ loading, buttonLabel, type, ...props }) => {
	return (
		<Grid container>
			<Grid
				item
				xs
				sx={{ display: 'flex', justifyContent: 'end' }}
				justifyContent={'flex-end'}>
				<Button
					variant="contained"
					type={type || 'submit'}
					fullWidth
					sx={{ minHeight: 50, fontSize: 16, mt: 5 }}
					{...props}>
					{loading ? 'Saving...' : buttonLabel ? buttonLabel : 'Save'}
				</Button>
			</Grid>
		</Grid>
	);
};

export default CustomButton;
